import CPGDesktop from 'cpg-nordic/desktop';
import headerCPG from './header-cpg';

export default headerCPG(CPGDesktop);
